export default function headerScript() {
  (function () {
    var isFixedScrollPositionActive = 50;

    var showButtonElements = document.querySelectorAll('.navbar-mobile__hamburger');
    var closeButtonElements = document.querySelectorAll('.navbar-mobile__close-button');

    function getCurrentScroll() {
      return document.documentElement.scrollTop;
    }

    function onScroll() {
      var scrollPosition = getCurrentScroll();

      if (scrollPosition >= isFixedScrollPositionActive) {
        document.querySelector('nav.navigation').classList.add('--is-fixed');
      } else {
        document.querySelector('nav.navigation').classList.remove('--is-fixed');
      }
    }

    function toggleNavigationSidedar() {
      var navListElements = document.querySelectorAll('#navbar-list');
      for (var i = 0; i < navListElements.length; i++) {
        var navListElement = navListElements[i];
        navListElement.classList.toggle('--is-visible');
      }
    }

    function hideEmptyHeaderDropdowns() {
      const headerDropdowns = document.querySelectorAll('.navbar-dropdown');
      for (let i = 0; i < headerDropdowns.length; i++) {
        const dropdown = headerDropdowns[i];
        const menu = dropdown.querySelector('.navbar-menu');
        if (menu && menu.children && menu.children.length === 0) {
          dropdown.setAttribute('hidden', true);
        }
      }
    }

    function init() {
      window.addEventListener('scroll', (element) => onScroll(element), { passive: true });
      for (var i = 0; i < showButtonElements.length; i++) {
        var showButtonElement = showButtonElements[i];
        showButtonElement.addEventListener('click', toggleNavigationSidedar);
      }
      for (var j = 0; j < closeButtonElements.length; j++) {
        var closeButtonElement = closeButtonElements[j];
        closeButtonElement.addEventListener('click', toggleNavigationSidedar);
      }
      hideEmptyHeaderDropdowns();
    }

    onScroll();
    init();
  })();
}
